// Service worker registration + update lifecycle.
// On a new release the SW's bytes change (build-id stamp), so the browser
// downloads a new worker, parks it in "waiting", and we surface a banner
// "Nova versão · Recarregar". Tap → postMessage SKIP_WAITING → app reloads
// when the new worker takes over.

import { el } from './dom.js';

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => {
        // Already a worker waiting (browser closed before previous prompt)
        if (reg.waiting) promptUpdate(reg.waiting);

        // New worker becoming installed
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              promptUpdate(installing);
            }
          });
        });

        // Re-check for updates periodically (every 30 min while app is open)
        setInterval(() => reg.update().catch(() => {}), 30 * 60 * 1000);

        // Also check on visibility change — coming back to the app after a
        // few hours should pull the new SW.
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            reg.update().catch(() => {});
          }
        });
      })
      .catch(() => {});

    // When the new SW takes control, reload so the page sees fresh assets.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      location.reload();
    });
  });
}

let banner: HTMLElement | null = null;

function promptUpdate(worker: ServiceWorker) {
  if (banner) return;
  banner = el(
    'div',
    { class: 'update-banner', role: 'alert' },
    [
      el('div', { class: 'update-banner__text' }, [
        el('strong', {}, ['Nova versão disponível']),
        el('div', { class: 'dim', style: 'font-size: var(--text-sm)' }, [
          'Atualize pra pegar as últimas mudanças.',
        ]),
      ]),
      el(
        'button',
        {
          class: 'btn btn--primary',
          type: 'button',
          onclick: () => {
            worker.postMessage({ type: 'SKIP_WAITING' });
            // controllerchange listener above will reload the page
          },
        },
        ['Recarregar'],
      ),
    ],
  );
  document.body.append(banner);
}
